var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("h2", { staticClass: "mb-10" }, [
          _vm._v(
            " " +
              _vm._s(_vm.reportTypeText) +
              " Informe de Desempeño Proceso de Calificaciones "
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-lg-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Tipo de Informe *" } },
                [
                  _c(
                    "b-form-select",
                    {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      staticClass: "w-100",
                      attrs: {
                        disabled: _vm.loadingReportTypes,
                        "data-cy": "report-type",
                        name: "reportType",
                        "data-vv-as": "tipo de informe",
                        state: _vm.errors.has("custom-document.reportType")
                          ? false
                          : null,
                        options: _vm.reportTypeOptions
                      },
                      on: { input: _vm.setReportType },
                      model: {
                        value: _vm.reportType,
                        callback: function($$v) {
                          _vm.reportType = $$v
                        },
                        expression: "reportType"
                      }
                    },
                    [
                      _vm.loadingReportTypes
                        ? _c(
                            "option",
                            {
                              attrs: { disabled: "" },
                              domProps: { value: null }
                            },
                            [_vm._v(" Cargando tipos de informe... ")]
                          )
                        : _c(
                            "option",
                            {
                              attrs: { disabled: "" },
                              domProps: { value: null }
                            },
                            [_vm._v(" -- Selecciona un tipo de informe -- ")]
                          )
                    ]
                  ),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "reportType",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-6 col-lg-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Inicio periodo (Auto)" } },
                [
                  _c("date-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      disabled: "",
                      placeholder: "Seleccione un tipo de informe",
                      "input-class": {
                        "mx-input": true,
                        "border-danger": _vm.errors.has(
                          "custom-document.initialDate"
                        )
                      },
                      "data-cy": "initial-date",
                      name: "initialDate",
                      format: "DD-MM-YYYY",
                      "value-type": "YYYY-MM-DD",
                      "data-vv-as": "fecha inicial",
                      danger: _vm.errors.has("custom-document.initialDate"),
                      "danger-text": _vm.errors.first(
                        "custom-document.initialDate"
                      )
                    },
                    model: {
                      value: _vm.formData.initialDate,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "initialDate", $$v)
                      },
                      expression: "formData.initialDate"
                    }
                  }),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "initialDate",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-6 col-lg-3" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Fin periodo (Auto)" } },
                [
                  _c("date-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      disabled: "",
                      placeholder: "Seleccione un tipo de informe",
                      "input-class": {
                        "mx-input": true,
                        "border-danger": _vm.errors.has(
                          "custom-document.finalDate"
                        )
                      },
                      "data-cy": "final-date",
                      name: "finalDate",
                      format: "DD-MM-YYYY",
                      "value-type": "YYYY-MM-DD",
                      "data-vv-as": "fecha final",
                      danger: _vm.errors.has("custom-document.finalDate"),
                      "danger-text": _vm.errors.first(
                        "custom-document.finalDate"
                      )
                    },
                    model: {
                      value: _vm.formData.finalDate,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "finalDate", $$v)
                      },
                      expression: "formData.finalDate"
                    }
                  }),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "finalDate",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Institución (Auto)" } },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      disabled: "",
                      state: _vm.errors.has("custom-document.institution")
                        ? false
                        : null,
                      "data-cy": "institution",
                      "data-vv-as": "institución",
                      name: "institution",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.institution,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "institution", $$v)
                      },
                      expression: "formData.institution"
                    }
                  }),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "institution",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "División *" } },
                [
                  _c("list-groups", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "division",
                    attrs: {
                      danger: _vm.errors.has("custom-document.division"),
                      "danger-text": _vm.errors.first(
                        "custom-document.division"
                      ),
                      "data-vv-as": "división",
                      autocomplete: "",
                      label: "",
                      name: "division",
                      "data-cy": "division",
                      typeList: _vm.stepTypes.GROUP,
                      showOnlyDivissions: ""
                    },
                    on: { "full-group": _vm.setDivision },
                    model: {
                      value: _vm.division,
                      callback: function($$v) {
                        _vm.division = $$v
                      },
                      expression: "division"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Funcionario *" } },
                [
                  _c("list-user", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "functionary",
                    staticClass: "w-100",
                    attrs: {
                      "division-filter": _vm.division,
                      autocomplete: "",
                      "data-cy": "functionary",
                      "data-vv-as": "funcionario",
                      name: "functionary",
                      label: "",
                      danger: _vm.errors.has("custom-document.functionary"),
                      "danger-text": _vm.errors.first(
                        "custom-document.functionary"
                      ),
                      "filters-user-group": "esOficina:N"
                    },
                    on: {
                      "set-position": _vm.setFunctionary,
                      input: _vm.resetFunctionary
                    },
                    model: {
                      value: _vm.functionary,
                      callback: function($$v) {
                        _vm.functionary = $$v
                      },
                      expression: "functionary"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Departamento *" } },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      disabled: _vm.loadingFunctionaryInfo,
                      state: _vm.errors.has("custom-document.department")
                        ? false
                        : null,
                      "data-cy": "department",
                      "data-vv-as": "departamento",
                      name: "department",
                      type: "text",
                      placeholder: _vm.departmentLoadingText
                    },
                    model: {
                      value: _vm.formData.department,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "department", $$v)
                      },
                      expression: "formData.department"
                    }
                  }),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "department",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-lg-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Estamento *" } },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      "data-cy": "estate",
                      name: "estate",
                      "data-vv-as": "estamento",
                      state: _vm.errors.has("custom-document.estate")
                        ? false
                        : null,
                      options: _vm.estateOptions
                    },
                    model: {
                      value: _vm.formData.estate,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "estate", $$v)
                      },
                      expression: "formData.estate"
                    }
                  }),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "estate",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-lg-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Grado *" } },
                [
                  _c("b-form-select", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      "data-cy": "degree",
                      name: "degree",
                      "data-vv-as": "grado",
                      state: _vm.errors.has("custom-document.degree")
                        ? false
                        : null,
                      options: _vm.degreeOptions
                    },
                    model: {
                      value: _vm.formData.degree,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "degree", $$v)
                      },
                      expression: "formData.degree"
                    }
                  }),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "degree",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 col-md-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Jefe/a Directo *" } },
                [
                  !_vm.disableDirectBossChange || _vm.directBoss == null
                    ? _c("list-user", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              required:
                                !_vm.disableDirectBossChange ||
                                _vm.directBoss == null
                            },
                            expression:
                              "{\n              'required': !disableDirectBossChange || directBoss == null\n            }"
                          }
                        ],
                        ref: "directBoss",
                        staticClass: "w-100",
                        attrs: {
                          disabled: _vm.loadingFunctionaryInfo,
                          autocomplete: "",
                          "data-cy": "direct-boss",
                          "data-vv-as": "jefe/a directo",
                          name: "directBoss",
                          label: "",
                          placeholder: _vm.loadingFunctionaryInfo
                            ? "Cargando..."
                            : null,
                          danger: _vm.errors.has("custom-document.directBoss"),
                          "danger-text": _vm.errors.first(
                            "custom-document.directBoss"
                          ),
                          "filters-user-group": "esOficina:N"
                        },
                        on: { "set-position": _vm.setDirectBoss },
                        model: {
                          value: _vm.directBoss,
                          callback: function($$v) {
                            _vm.directBoss = $$v
                          },
                          expression: "directBoss"
                        }
                      })
                    : _c("b-form-input", {
                        attrs: {
                          disabled: "",
                          "data-cy": "directBoss",
                          name: "directBoss",
                          type: "text",
                          placeholder: "Cargando...",
                          value: _vm.directBoss || "Cargando..."
                        },
                        model: {
                          value: _vm.formData.directBoss,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "directBoss", $$v)
                          },
                          expression: "formData.directBoss"
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.workAmount")
                        ? false
                        : null,
                      "data-cy": "work-amount",
                      "data-vv-as": "cantidad de trabajo",
                      name: "workAmount",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.workAmount,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workAmount", $$v)
                      },
                      expression: "formData.workAmount"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.workAmount.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "workAmount",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._m(1),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.workQuality")
                        ? false
                        : null,
                      "data-cy": "work-quality",
                      "data-vv-as": "calidad de la labor realizada",
                      name: "workQuality",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.workQuality,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workQuality", $$v)
                      },
                      expression: "formData.workQuality"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.workQuality.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "workQuality",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._m(2),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.attentionQuality")
                        ? false
                        : null,
                      "data-cy": "attention-quality",
                      "data-vv-as": "calidad de la atención",
                      name: "attentionQuality",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.attentionQuality,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "attentionQuality", $$v)
                      },
                      expression: "formData.attentionQuality"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.attentionQuality.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "attentionQuality",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _vm._m(3),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.workKnowledge")
                        ? false
                        : null,
                      "data-cy": "work-knowledge",
                      "data-vv-as": "conocimiento del trabajo",
                      name: "workKnowledge",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.workKnowledge,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workKnowledge", $$v)
                      },
                      expression: "formData.workKnowledge"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.workKnowledge.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "workKnowledge",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._m(4),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.workInterest")
                        ? false
                        : null,
                      "data-cy": "work-interest",
                      "data-vv-as": "interés por el trabajo",
                      name: "workInterest",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.workInterest,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workInterest", $$v)
                      },
                      expression: "formData.workInterest"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.workInterest.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "workInterest",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._m(5),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.workInitiative")
                        ? false
                        : null,
                      "data-cy": "work-initiative",
                      "data-vv-as": "capacidad para actuar oportunamente",
                      name: "workInitiative",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.workInitiative,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workInitiative", $$v)
                      },
                      expression: "formData.workInitiative"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.workInitiative.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "workInitiative",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._m(6),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.workGroup")
                        ? false
                        : null,
                      "data-cy": "work-group",
                      "data-vv-as": "capacidad para realizar trabajos en grupo",
                      name: "workGroup",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.workGroup,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workGroup", $$v)
                      },
                      expression: "formData.workGroup"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.workGroup.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "workGroup",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _vm._m(7),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has(
                        "custom-document.attendancePunctuality"
                      )
                        ? false
                        : null,
                      "data-cy": "attendance-punctuality",
                      "data-vv-as": "asistencia y puntualidad",
                      name: "attendancePunctuality",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.attendancePunctuality,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "attendancePunctuality", $$v)
                      },
                      expression: "formData.attendancePunctuality"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.attendancePunctuality.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "attendancePunctuality",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._m(8),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has(
                        "custom-document.workplacePermanence"
                      )
                        ? false
                        : null,
                      "data-cy": "workplace-permanence",
                      "data-vv-as": "permanencia en el lugar de trabajo",
                      name: "workplacePermanence",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.workplacePermanence,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "workplacePermanence", $$v)
                      },
                      expression: "formData.workplacePermanence"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.workplacePermanence.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "workplacePermanence",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._m(9),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-textarea", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "-mt-2",
                    attrs: {
                      rows: "4",
                      state: _vm.errors.has("custom-document.rulesCompliance")
                        ? false
                        : null,
                      "data-cy": "rules-compliance",
                      "data-vv-as": "cumplimiento de normas e instrucciones",
                      name: "rulesCompliance",
                      maxlength: _vm.inputMaxLength
                    },
                    model: {
                      value: _vm.formData.rulesCompliance,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "rulesCompliance", $$v)
                      },
                      expression: "formData.rulesCompliance"
                    }
                  }),
                  _c("div", { staticClass: "text-right" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Contador de caracteres",
                            expression: "'Contador de caracteres'"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formData.rulesCompliance.length) +
                            "/" +
                            _vm._s(_vm.inputMaxLength) +
                            " "
                        )
                      ]
                    )
                  ]),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "rulesCompliance",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-6 col-xl-4" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Fecha Conocimiento *" } },
                [
                  _c("date-picker", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      placeholder: "Seleccione una fecha",
                      "input-class": {
                        "mx-input": true,
                        "border-danger": _vm.errors.has(
                          "custom-document.knowledgeDate"
                        )
                      },
                      "data-cy": "knowledge-date",
                      name: "knowledgeDate",
                      format: "DD-MM-YYYY",
                      "value-type": "YYYY-MM-DD",
                      "data-vv-as": "fecha de conocimiento",
                      danger: _vm.errors.has("custom-document.knowledgeDate"),
                      "danger-text": _vm.errors.first(
                        "custom-document.knowledgeDate"
                      )
                    },
                    model: {
                      value: _vm.formData.knowledgeDate,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "knowledgeDate", $$v)
                      },
                      expression: "formData.knowledgeDate"
                    }
                  }),
                  _c("ValidationError", {
                    attrs: {
                      document: "custom-document",
                      validation: "knowledgeDate",
                      "validator-errors": _vm.errors
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    ),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "vs-button",
          {
            staticClass: "mt-5 mr-5",
            attrs: {
              "data-cy": "cancel",
              color: "primary",
              disabled: _vm.saving
            },
            on: {
              click: function($event) {
                return _vm.back()
              }
            }
          },
          [_vm._v(" Cancelar ")]
        ),
        _c(
          "vs-button",
          {
            staticClass: "mt-5 mr-5",
            attrs: {
              "data-cy": "save",
              color: "success",
              disabled: _vm.saving
            },
            on: {
              click: function($event) {
                return _vm.save()
              }
            }
          },
          [
            _vm._v(" Crear "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.saving,
                  expression: "saving"
                }
              ],
              staticClass: "spinner-border spinner-border-sm text-primary"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("1. "), _c("u", [_vm._v("RENDIMIENTO")]), _vm._v(":")]),
        _vm._v(
          " Mide el volumen de trabajo ejecutado y la calidad durante el período, destacando la ausencia de errores en relación a las tareas encomendadas. "
        )
      ]),
      _c("p", [
        _c("b", [_vm._v("1.a.")]),
        _vm._v(" "),
        _c("u", [_vm._v("Cantidad de Trabajo")]),
        _vm._v(
          ": Mide el volumen de trabajo desarrollado y la rapidez y oportunidad de su ejecución. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("1.b.")]),
        _vm._v(" "),
        _c("u", [_vm._v("Calidad de la labor realizada")]),
        _vm._v(
          ": Evalúa las características de la labor cumplida. Mide la ausencia de errores en el trabajo y la habilidad en su ejecución. "
        )
      ]),
      _c("p", [
        _c("b", [_vm._v("1.b.1.-")]),
        _vm._v(" "),
        _c("u", [
          _vm._v(
            "Ausencia de errores en el trabajo y habilidad en la ejecución de la tarea"
          )
        ]),
        _vm._v(". ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("1.b.2.-")]),
        _vm._v(" "),
        _c("u", [
          _vm._v("Calidad de la Atención y Trato al Usuario o Cliente Interno")
        ]),
        _vm._v(
          ": Mide el grado de amabilidad, cortesía, disposición y trato al usuario interno y externo. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [
          _vm._v("2. "),
          _c("u", [_vm._v("CONDICIONES PERSONALES")]),
          _vm._v(":")
        ]),
        _vm._v(
          " Evalúa aquellas aptitudes del funcionario vinculadas directamente con el cumplimiento de sus funciones. "
        )
      ]),
      _c("p", [
        _c("b", [_vm._v("2.a.-")]),
        _vm._v(" "),
        _c("u", [_vm._v("Conocimiento del trabajo")]),
        _vm._v(
          ": Mide el grado de conocimiento que la persona tiene de la actividad que realiza, los conocimientos teóricos, estudios y los cursos de formación o de especialización relacionados con las funciones del cargo. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("2.b.-")]),
        _vm._v(" "),
        _c("u", [_vm._v("Interés por el trabajo que realiza")]),
        _vm._v(
          ": Mide el deseo del funcionario de perfeccionarse en el cumplimiento de sus obligaciones y la capacidad de obrar oportunamente, de proponer la realización de actividades y de soluciones ante los problemas que se presenten y de proponer objetivos o procedimientos nuevos para la mejor realización del trabajo asignado. "
        )
      ]),
      _c("p", [
        _c("b", [_vm._v("2.b.1-")]),
        _vm._v(" "),
        _c("u", [_vm._v("Interés por perfeccionarse")]),
        _vm._v(
          ": Mide el deseo del funcionario de perfeccionarse en el cumplimiento de sus obligaciones, de adquirir nuevos conocimientos y grado de aplicación de estos. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("2.b.2-")]),
        _vm._v(" "),
        _c("u", [
          _vm._v(
            "Capacidad para actuar oportunamente, Grado de Iniciativa en el Trabajo"
          )
        ]),
        _vm._v(
          ": Mide el nivel de iniciativa que tiene el funcionario para resolver situaciones de menor envergadura, que se presentan a diario en su tarea. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("2.c-")]),
        _vm._v(" "),
        _c("u", [_vm._v("Capacidad para realizar trabajos en grupo")]),
        _vm._v(
          ": Mide la facilidad de integración del funcionario en equipos de trabajo, así como la colaboración eficaz que este presta cuando se requiere que trabaje con grupo de personas. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [
          _vm._v("3. "),
          _c("u", [_vm._v("COMPORTAMIENTO FUNCIONARIO/A")]),
          _vm._v(":")
        ]),
        _vm._v(
          " Evalúa la conducta del funcionario en el cumplimiento de sus obligaciones, normas y procedimientos establecidos en la Institución y en las normas jurídicas que regulan la actividad. "
        )
      ]),
      _c("p", [
        _c("b", [_vm._v("3.a-")]),
        _vm._v(" "),
        _c("u", [_vm._v("Asistencia y Puntualidad")]),
        _vm._v(
          ": Mide la presencia o ausencia del funcionario en el lugar de trabajo y la exactitud en el cumplimiento de la jornada laboral. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("3.b-")]),
        _vm._v(" "),
        _c("u", [_vm._v("Permanencia en el lugar de trabajo")]),
        _vm._v(
          ": Mide la presencia del funcionario en su puesto de trabajo, sin considerar la ausencia por motivos laborales (reuniones, cometidos funcionarios, etc.). "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("p", [
        _c("b", [_vm._v("3.c-")]),
        _vm._v(" "),
        _c("u", [_vm._v("Cumplimiento de normas e instrucciones")]),
        _vm._v(
          ": Mide el adecuado y oportuno respeto a los reglamentos e instrucciones de la Institución, a los demás deberes estatutarios, al cumplimiento de las tareas propias del cargo, y de las órdenes y cometidos que le impartan o encomienden sus superiores. "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }